var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFootprint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235,
    height: 235,
    viewBox: "0 0 235 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.463 116.463C95.7747 137.151 104.232 184.472 121.048 201.288C129.404 209.644 145.516 206.623 157.729 194.41C162.322 189.817 164.386 185.722 166.208 182.109C167.874 178.803 169.314 175.948 172.631 172.631C175.948 169.314 178.803 167.874 182.109 166.208C185.722 164.386 189.817 162.322 194.41 157.729C206.623 145.516 209.644 129.404 201.288 121.048C184.472 104.232 137.15 95.775 116.463 116.463Z",
    fill: "#FBB540",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0567 79.323C28.415 88.9647 32.4431 108.098 47.227 122.882C62.0109 137.666 81.1442 141.694 90.7859 132.052C100.428 122.411 96.3995 103.277 81.6156 88.4933C66.8317 73.7094 47.6983 69.6814 38.0567 79.323Z",
    fill: "#FBB540",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.323 38.0567C69.6814 47.6984 73.7094 66.8317 88.4933 81.6156C103.277 96.3995 122.411 100.428 132.052 90.7859C141.694 81.1443 137.666 62.0109 122.882 47.227C108.098 32.4432 88.9647 28.4151 79.323 38.0567Z",
    fill: "#FBB540",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2996 146.003C64.3573 142.322 52.7027 147.668 50.1965 156.933C47.6655 166.288 55.4538 176.555 69.069 180.452C82.7614 184.37 94.8097 178.465 97.1722 169.521C99.5868 160.378 92.1352 149.655 78.2996 146.003Z",
    fill: "#FBB540",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.933 50.1963C147.668 52.7025 142.322 64.3571 146.002 78.2993C149.655 92.135 160.377 99.5866 169.52 97.172C178.465 94.8098 184.37 82.7614 180.451 69.069C176.554 55.4536 166.288 47.6658 156.933 50.1963Z",
    fill: "#FBB540",
    fillOpacity: 0.15
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 166,
    height: 166,
    fill: "white",
    transform: "translate(0 117.38) rotate(-45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootprint);
export default __webpack_public_path__ + "static/media/footprint.c0d5ccfecceb9c89f8568502846e0bbd.svg";
export { ForwardRef as ReactComponent };